// extracted by mini-css-extract-plugin
module.exports = {"contactContainer":"contactInfoWithIcon_contactContainer__b8m2Y","contactTextBox":"contactInfoWithIcon_contactTextBox__AI8Eq"};